import aws from '../assets/aws.jpg'
import coursera from '../assets/coursera.jpeg';
import toeic from '../assets/toeic.png';

const certificationsFiles = [
  {
    "year": "2020",
    "items": [
      {
        "id": 0,
        "name": "AWS Solutions Architect - Associate.jpg",
        "logo": aws,
        "height": "50%",
        "width": "75%",
        "details": [
          {"key": "Name", "value": "AWS Solutions Architect - Associate"},
          {"key": "Date of issue", "value": "November 1st, 2020"},
          {"key": "ID", "value": "9K392EQB2FR11QSB"},
          {"key": "Link", "value": "https://www.youracclaim.com/badges/2fd69470-e0df-4cd0-aec4-4be55a1d595a"}
        ]
      },
    ]
  },
  {
    "year": "2019",
    "items": [
      {
        "id": 1,
        "name": "Coursera - Machine Learning.jpg",
        "logo": coursera,
        "height": "70%",
        "width": "100%",
        "details": [
          {"key": "Name", "value": "Coursera - Machine Learning"},
          {"key": "Date of issue", "value": "February 10th, 2019"},
          {"key": "ID", "value": "3ZTK5DFKMKU4"},
          {"key": "Link", "value": "https://www.coursera.org/account/accomplishments/verify/3ZTK5DFKMKU4"}
        ]
      },
    ]
  },
  {
    "year": "2017",
    "items": [
      {
        "id": 2,
        "name": "TOEIC.png",
        "logo": toeic,
        "height": "30%",
        "width": "60%",
        "details": [
          {"key": "Name", "value": "TOEIC"},
          {"key": "Score", "value": "970/990"},
          {"key": "Date of issue", "value": "December 20th, 2017"},
          {"key": "Description", "value": "Test of English for International Communication Listening and Reading test. A minimum score of 785 was mandatory before my Master graduation. This certificate assesses my English-language listening and reading skills to the Common European Framework of Reference for Languages (CEFR) C1-level."}
        ]
      }
    ]
  }
]

export default certificationsFiles;